export const WOOD_CLUB_ID = 1;

export const FRONTEND_WEAPONS = new Set([
  'WoodClub',
  'StoneClub',
  'FlintHammer',
  'Nerd Weapon',
  'ObsidianClub',
  'Machete',
  'IceClub',
  'Baton',
  'BoneAxe',
  'Meat',
  'AmberStaff',
  'Sword',
  'ShamanStaff',
  'Boogatooth Lure',
]);

export const WEAPON_DISPLAY_ALIASES: Record<string, string> = {
  'Wood Club': 'WoodClub',
  'Stone Club': 'StoneClub',
  'Flint Hammer': 'FlintHammer',
  'Ice Club': 'IceClub',
  'Bone Axe': 'BoneAxe',
  'Obsidian Club': 'ObsidianClub',
  'Amber Staff': 'AmberStaff',
  'Shaman Staff': 'ShamanStaff',
  'Boogatooth Lure': 'Boogatooth Lure',
};

export const CATALOG_WEAPON_STATS: Record<string, { damage: number; precision: number }> = {
  WoodClub: { damage: 1, precision: 50 },
};

export function resolveWeaponName(name: string) {
  if (!name) return '';
  const trimmed = name.replace('.png', '').trim();
  if (FRONTEND_WEAPONS.has(trimmed)) return trimmed;
  return WEAPON_DISPLAY_ALIASES[trimmed] ?? trimmed;
}

export function isFrontendWeapon(name: string) {
  return Boolean(name && FRONTEND_WEAPONS.has(name));
}

export function resolveServerWeapon({
  WeaponId,
  weaponId,
  Name,
  name,
}: {
  WeaponId?: number | null;
  weaponId?: number | null;
  Name?: string;
  name?: string;
} = {}) {
  const id = WeaponId ?? weaponId ?? null;
  const label = String(Name ?? name ?? '').trim();

  if (id === WOOD_CLUB_ID || label === 'WoodClub') {
    return { clientName: 'WoodClub', weaponId: WOOD_CLUB_ID };
  }

  const aliased = WEAPON_DISPLAY_ALIASES[label] ?? label;
  if (aliased && FRONTEND_WEAPONS.has(aliased)) {
    return { clientName: aliased, weaponId: id ?? null };
  }

  if (label && FRONTEND_WEAPONS.has(label)) {
    return { clientName: label, weaponId: id ?? null };
  }

  return null;
}

export function equippedIdToClientWeapon(equippedWeaponId: number | null | undefined) {
  if (equippedWeaponId == null || equippedWeaponId === WOOD_CLUB_ID) {
    return 'WoodClub';
  }
  return null;
}

export function parseEquippedWeaponId(raw: unknown) {
  if (raw == null) return null;
  if (typeof raw === 'number' && !Number.isNaN(raw)) return raw;
  const resolved = resolveServerWeapon({ Name: String(raw) });
  return resolved?.weaponId ?? null;
}

export function resolveServerItem({
  ItemId,
  itemId,
  Name,
  name,
}: {
  ItemId?: number | null;
  itemId?: number | null;
  Name?: string;
  name?: string;
} = {}) {
  const label = String(Name ?? name ?? '').trim();
  if (label) return label;
  const id = ItemId ?? itemId ?? null;
  if (id === 2) return 'Stone';
  if (id === 1) return 'Opal';
  return '';
}

export function clientItemToItemId(itemName: string) {
  if (itemName === 'Stone') return 2;
  if (itemName === 'Opal') return 1;
  return null;
}

export function inferCategory(name: string) {
  if (!name) return 'misc';
  if (name === 'Boogatooth Lure' || FRONTEND_WEAPONS.has(name)) return 'weapon';
  if (name.includes('Pink Hunter') || name.includes('Shoulderpads') || name.includes('Pants')) return 'armor';
  if (['Leather', 'Claws', 'Pink Fur', 'Stone', 'Wood'].some((m) => name.includes(m))) return 'material';
  return 'misc';
}
